import { type AllergyData, AllergyLevel } from "@qendo/medical/allergy";
import { MedicalType } from "@qendo/medical/types";
import Data from "~/util/data";

export class Allergy extends Data implements AllergyData {
    public readonly type = MedicalType.allergy;

    public constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public flag = false,
        public level: AllergyLevel = AllergyLevel.known,
    ) {
        super();
    }
}
